/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export enum ButtonVariant {
  Default = 'default',
  Icon = 'icon',
  Outline = 'outline',
  None = 'none'
}
